module.exports = __webpack_public_path__ + "static/media/obs.b1489fc6.png";